import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'underscore';
import { IDropdownSettings } from 'ng-multiselect-dropdown/multiselect.model';
import { ApiService } from '../../services/api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { StorageService } from '../../services/storage.service';

@Component({
  selector: 'app-modal-ips',
  templateUrl: './modal-ips.component.html',
  styleUrls: ['./modal-ips.component.scss'],
})
export class ModalIpsComponent implements OnInit {

    @Input() corPrimaria: string;
    @Input() title: string;
    @Input() conteudo: any;
    @Output() fecharModal = new EventEmitter();

    constructor(private toast: ToastrService,
                private api: ApiService,
                private loading: NgxSpinnerService,
                private storage: StorageService) {
    }

    ngOnInit() {
        console.log('title: ', this.title);
        //console.log('text: ', this.text);
        console.log('conteudo: ', this.conteudo);
        //console.log('downloads: ', this.downloads);
        //console.log('aplicativo: ', this.aplicativo);
    }

    fechar(bol) {
        this.fecharModal.emit();
    }

    adicionar() {
        this.fecharModal.emit();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modal-ips/modal-ips.component.ts